import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

const getRejectPartsManualAdjustmentEnabled = createSelector(
  [getLaunchDarklyFlags],
  (flags) => {
    return flags?.[FLAG_KEYS.REJECT_PARTS_MANUAL_ADJUSTMENT_ENABLED] || false;
  }
);

export { getRejectPartsManualAdjustmentEnabled };
